let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4FECW")).then(() => parcelRequire('73vbP'));